
export const APP_WCRS_DEV = 'https://dev-wcrs.familycare.ai/home'
export const APP_WCRS_PROD = 'https://n-wcrs.familycare.ai/home'
export const APP_STORE_WARD = 'https://play.google.com/store/apps/details?id=co.kr.datau.tesla_p'
export const IOS_APP_STORE_WARD = 'https://teslag.page.link/yCMn'
export const DATAU_HOMEPAGE = 'http://datauniverse.co.kr'
export const MO_APP_STORE_WARD = 'https://teslag.page.link/iGuj'
export const SERVICE_CANCEL_HOST = 'servicecancel'
